<template>
  <div class="lengend" :class="pz">
    <div class="flex-around topNav">
      <div class="box">
        <div class="flex warn-table">
          <div
            class="flex"
            :class="curname === '人员指数' ? 'active' : ''"
            @click="updcur('人员指数')"
          >
            <div class="imgs flex">
              <img src="@/assets/images/schj/ico_ry.png" alt="" />
            </div>
            <div class="item-val-box">
              <div class="item-val">
                {{ ry }}<img class="jt-img" :src="ryImg" alt="" />
              </div>
              <div>人员指数</div>
            </div>
          </div>
          <div
            class="flex"
            :class="curname === '车辆指数' ? 'active' : ''"
            @click="updcur('车辆指数')"
          >
            <div class="imgs flex">
              <img src="@/assets/images/schj/ico_cl.png" alt="" />
            </div>
            <div class="item-val-box">
              <div class="item-val">
                {{ cl }}
                <img class="jt-img" :src="clImg" alt="" />
              </div>
              <div>车辆指数</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pz: {
      type: String,
      default: ""
    },
    ry: {
      type: String,
      default: "10000"
    },
    cl: {
      type: String,
      default: "65"
    },
    curname: {
      type: String,
      default: "人员指数"
    }
  },
  computed: {
    ryImg() {
      if (this.ry >= 0) {
        return require("@/assets/images/schj/zj.gif");
      } else {
        return require("@/assets/images/schj/js.gif");
      }
    },
    clImg() {
      if (this.cl >= 0) {
        return require("@/assets/images/schj/zj.gif");
      } else {
        return require("@/assets/images/schj/js.gif");
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    updcur(name) {
      if (this.curname !== name) {
        this.$emit("updcur", name);
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.lengend.left-top
  right unset
  left 26.5%
.lengend.left-zl
  left 5px
.lengend
  position absolute
  background-color red
  color #fff
  z-index 401
  top .54rem
  right 27%
  width 8.2%
  padding 5px
  border 1px solid #00A9C7
  background-color rgba(1,29,46, 0.8)
  box-shadow inset 0 0 0.05208rem #00b1cf
  border-radius 5px
  font-size 0.08rem
  transition .3s
  >>>.el-checkbox__inner
    border-color #1EC4F8
  >>>.el-checkbox__input.is-checked
    border-color #1EC4F8
  .imgs
    background url('~images/schj/ico_bg.png') no-repeat
    background-size 100% 100%
    width 60px
    height 60px
    justify-content center
  .item-val-box
    text-align center
    flex 1
    font-size 13px
    .item-val
        color #30FDFF
        font-size 20px
  .jt-img
    width 20px
    display unset


.mainList
  flex-wrap wrap
  width 100%
  height 100%
.lengCube
  width 50%
  height 23%
.lengCube:last-child
  padding-bottom 0
.imggs
  width 36px
  display flex
  justify-content center
  margin-right 5px
@media (min-height 1400px)
  .lengend
    font-size 0.06rem
    padding 5px 20px
.topNav
  z-index 9
  color #ccc
  display flex
  flex-direction column
  width 100%
  height 100%
  display flex


.active
  color #fff
  background-color #0D719F
.box
  width 100%
.warn-table
  padding 5px 0 5px 7px
  height calc(100% - 10px)
  overflow-y auto
  flex-wrap wrap
  &::-webkit-scrollbar
    width 4px
    background-color #19295a
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
  > div.flex
    width 100%
    margin-top 4px
    cursor pointer
  .flex.active
    background: rgba(101,84,84,0.45)

.warn-tables
  display flex
  justify-content center
  align-items center
  width 100%

.point-zzdh-y
  width 10px
  height 10px
  border-radius 50%
  background #f3d013
@media (max-width 1280px)
  .imggs
    margin-right 0px
</style>
